import React, { useContext } from 'react';
import { toString } from 'lodash';
import { CustomSelect } from 'components';
import FeaturedSpreadsheetContext from 'components/FeaturedSpreadsheet/context/FeaturedSpreadsheetContext';
import { FinancialStatementPeriodsProps } from './types';

const FinancialStatementPeriods = ({ cell, options, ...restProps }: FinancialStatementPeriodsProps) => {
  const { onCommit, onRevert } = restProps;
  const { onCellsChanged } = useContext(FeaturedSpreadsheetContext);

  const handleChange = (value: string | null) => {
    const newValue = toString(value);
    onCellsChanged([{ cell, value: newValue }]);
  };

  return (
    <CustomSelect
      id={`financial-statement-periods-${cell.key}`}
      value={cell.value as string}
      options={options}
      onChange={handleChange}
      onCommit={onCommit}
      onRevert={onRevert}
      disabled={cell.readOnly}
      onEmptyValue=""
    />
  );
};

export default FinancialStatementPeriods;
